<script lang="ts">
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import * as typeformEmbed from '@typeform/embed';
	import { dev } from '$app/environment';

	interface Props {
		formId: string;
		lazy?: boolean;
		rounded?: boolean;
		onsubmit?: (data: { formId: string; responseId: string }) => void;
	}

	let { formId, lazy = false, rounded = true, onsubmit }: Props = $props();

	let container: HTMLDivElement;

	onMount(() => {
		typeformEmbed.createWidget(formId, {
			enableSandbox: dev,
			container: container,
			lazy,
			noScrollbars: true,
			height: '100%',
			width: '100%',
			iframeProps: {
				height: '100%',
				width: '100%'
			},
			inlineOnMobile: true,
			onSubmit: async ({ formId, responseId }) => {
				onsubmit?.({ formId, responseId });
			}
		});
	});
</script>

<div
	class="typeform flex h-full min-h-[650px] w-full items-center justify-center overflow-auto bg-stone-4"
	class:rounded-xl={rounded}
	bind:this={container}
	in:fade
></div>

<style lang="scss">
	.typeform {
		:global {
			& > button {
				display: none;
			}
		}
	}
</style>
